import script from "./lisuanMarketing.vue?vue&type=script&setup=true&lang=js"
export * from "./lisuanMarketing.vue?vue&type=script&setup=true&lang=js"

import "./lisuanMarketing.vue?vue&type=style&index=0&id=af8f4018&lang=scss"

const __exports__ = script;

export default __exports__